export default {
    props: {
        // {honda: 'The power of dreams', bmw: 'B M W' }
        // or
        // [{value: 'honda', text: 'The power of dreams', visible: () => false, disabled: () => true, attrs: {}}, ...]
        // or
        // ['Car', 'Bus']
        options: {
            type: [Object, Array, Function],
            default: () => []
        },
    },
    data() {
        return {
            preparedOptions: []
        }
    },
    methods: {
        isVisible(option) {
            return typeOf(option.visible) === 'function' ? option.visible() : option.visible
        },
        isDisabled(option) {
            return typeOf(option.disabled) === 'function' ? option.disabled() : option.disabled
        }
    },
    computed: {
        optionsConverted() {
            this.preparedOptions = []

            let options = this.options

            if( typeOf(options) === 'function' ) {
                options = options()
            }

            if( isObject(options) ) {
                for( let value in options ) {
                    this.preparedOptions.push({
                        text: options[value],
                        value: String(value),
                        visible: true,
                        disabled: false
                    })
                }

                return this.preparedOptions
            }

            options.forEach((text, value) => {
                let opt

                if ( typeof text === 'string' || typeof text === 'number' ) {
                    opt = {text, value: String(value)}
                } else {
                    opt = Object.assign({}, text)

                    if( opt.value !== undefined ) {
                        opt.value = String(opt.value)
                    }
                }

                if( opt.visible === undefined ) {
                    opt.visible = true
                }

                if( opt.disabled === undefined ) {
                    opt.disabled = false
                }

                this.preparedOptions.push( opt )
            })

            return this.preparedOptions
        }
    }
}
